import { setRequestFromHeader } from '@h5-journey/platform'
import {
  getUniqueId,
  isInApp,
  isInHostMiniAppWebView,
  syncHostMiniAppSession
} from '@h5-journey/utils'

/**
 * 首个业务请求前设置站点来源，返回是否已初始化。
 * @param preserveHostSource 默认保留宿主协议；不执行平台初始化的独立站点可设为 false。
 */
export function initializeH5RequestFromHeader(client: string, preserveHostSource = true): boolean {
  syncHostMiniAppSession()
  if (preserveHostSource && (isInApp() || isInHostMiniAppWebView())) return false

  setRequestFromHeader({ client, version: '1.0.0', cuid: getUniqueId() })
  return true
}
